var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "home" } },
    [
      _c("left-sidebar"),
      _vm._v(" "),
      _c("network-map", {
        on: {
          loading: function($event) {
            _vm.pageIsLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("right-sidebar-close"),
      _vm._v(" "),
      _c("right-sidebar-open", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.sidebarIsOpen,
            expression: "sidebarIsOpen"
          }
        ]
      }),
      _vm._v(" "),
      _c("loading-spinner", {
        attrs: {
          active: _vm.pageIsLoading,
          "is-full-page": true,
          color: "#4fa2b7",
          height: 200,
          width: 200
        },
        on: {
          "update:active": function($event) {
            _vm.pageIsLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.isDialogOpen
        ? _c("select-workspace-dialog-box", {
            staticStyle: { "z-index": "10" },
            attrs: {
              "workspace-options": _vm.workspacesContainObject,
              workspaces: _vm.workspaces,
              "object-coordinate": _vm.objectCoordinate
            },
            on: {
              close: _vm.closeSelectWorkspaceDialogBox,
              confirm: _vm.openOnWorkspace
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.workspacesContainObject && _vm.workspacesContainObject.length === 0
        ? _c("workspaces-not-found-dialog-box", {
            staticStyle: { "z-index": "10" },
            on: { close: _vm.closeSelectWorkspaceDialogBox }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f6732a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f6732a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Network/Network.vue
// module id = null
// module chunks = 